import { tips } from "../../../mocks/guaData";
import Reveal from "./Reveal";
import SectionHead from "./SectionHead";

export default function SpotTips() {
  return (
    <section id="spot" className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHead
          align="center"
          eyebrow="防晕指南 · 理性吃瓜"
          title="四个习惯，帮你一眼识破套路"
          desc="掌握这些小技巧，从此吃瓜不上头、不迷路，也更不容易被情绪带着跑。"
        />
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {tips.map((t, i) => (
            <Reveal key={t.title} delay={i * 80}>
              <div className="flex h-full flex-col rounded-xl border border-background-200 bg-background-100 p-6">
                <span className="flex h-12 w-12 items-center justify-center rounded-full bg-secondary-500 text-background-50">
                  <i className={`${t.icon} text-2xl`} aria-hidden="true"></i>
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold text-foreground-950">{t.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{t.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}